import React from 'react';
import { ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Rodal from '../../../Rodal/Rodal';
import PracticeProfileImages from '../../../PracticeProfileImages/PracticeProfileImages';
import { PracticeProfileImage } from '../../../../slices/profiles-data-slice/models/practice-profile-image';
import './LocationImagesModal.scss';

interface LocationImagesModalProps {
    isVisible: boolean;
    setIsVisible(isVisible: boolean): void;
    locationName: string;
    locationId: string;
    profileId: string;
    practiceProfileId: string;
    images: PracticeProfileImage[];
    isEditable?: boolean;
}

const MAX_IMAGES_PER_LOCATION = 30;

const LocationImagesModal: React.FC<LocationImagesModalProps> = ({
    isVisible,
    setIsVisible,
    locationName,
    locationId,
    profileId,
    practiceProfileId,
    images,
    isEditable = true,
}) => {
    if (!isVisible) {
        return null;
    }

    return (
        <Rodal
            visible={true}
            animation="slideTop"
            width={640}
            showCloseButton={false}
            onClose={() => setIsVisible(false)}
            className="location-images-modal">
            <ModalHeader>
                {locationName ? `${locationName} — Images` : 'Location Images'}
            </ModalHeader>
            <ModalBody>
                <PracticeProfileImages
                    key={`${locationId}-${images.length}`}
                    images={images}
                    profileId={profileId}
                    practiceProfileId={practiceProfileId}
                    locationId={locationId}
                    maxImages={MAX_IMAGES_PER_LOCATION}
                    disabled={!isEditable}
                />
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => setIsVisible(false)}>
                    Close
                </Button>
            </ModalFooter>
        </Rodal>
    );
};

export default LocationImagesModal;
